
import api from '@/api';

export default {
    namespaced: true,

    state: {
        // Массив сделок пользователя
        deals       : [],
        // выбранная сделка для показа
        selectedDeal: null
    },

    getters: {
        GET_DEALS(state) {
            return state.deals;
        },

        GET_SELECTED_DEAL(state) {
            return state.selectedDeal;
        }
    },

    actions: {
        async getDeals({rootState}) {
            const data = {
                userId: rootState.userId
            };

            return await api.post('/orders', data)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    throw error;
                });
        },

        selectDeal({commit}, deal) {
            commit('SET_SELECTED_DEAL', deal);
        }
    },

    mutations: {
        SET_SELECTED_DEAL(state, deal) {
            state.selectedDeal = deal;
        }
    }
};
